'use client';

import { FC } from 'react';
import { useRouter, usePathname } from 'next/navigation';
import { FlatButton } from '@puzzlio/ui';
import { AvatarButton } from '@/app/components/new-ui/atoms/avatar-button';
import { CommentRepliesButton } from '@/app/components/new-ui/molecules/comment-replies-button';
import { useUser } from '@/app/providers/UserProvider';
import { cn } from '@/app/lib/utils';

export const AuthButtons: FC<{ className?: string; redirectTo?: string; source?: string }> = ({
  className,
  redirectTo,
  source,
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const email = useUser()?.auth?.email;

  if (email) {
    return (
      <div className={cn('flex items-center gap-1.5', className)}>
        <CommentRepliesButton />
        <AvatarButton initial={email.at(0)?.toUpperCase() || '?'} />
      </div>
    );
  }

  // Carry the caller's post-auth destination to the signup page, tagged with a signup-wall source: the
  // caller's `source` if it's being preserved, else 'header' since this is the global header button.
  const params = new URLSearchParams();
  if (redirectTo && redirectTo !== '/') params.set('redirect_to', redirectTo);
  params.set('source', source ?? 'header');

  return (
    <FlatButton
      ph-autocapture="true"
      onClick={() => router.push(`/auth/signup?${params}`)}
      disabled={pathname === '/auth/signup'}
      className={cn('h-[34px] border-0 text-sm lg:h-auto lg:border-2', className)}
    >
      Sign Up
    </FlatButton>
  );
};
